(function($) {
	$(function() {
		function Form($form, options) {

			this._$form = $form;
			this.name = this._$form.data('name') || 'demo';//because demo forms are the most important
			var self = this,
			    defaults = {
			    	setAutoFocus: false,
			    	multySteps: false
			    };

			this.init = function(callback) {
				options = $.extend(defaults, options);

				this.$contentBlock = this._$form.find('.content-block');
				this.$successBlock = this._$form.find('.success-block');
				this.$errorBlock = this._$form.find('.error-block');
				this.$apiErrorBlock = this._$form.find('.api-error-block');
				this.$requiredFields = this._$form.find('.required');

				this.getSettings(function() {
					// self.$requiredFields = self._$form.find('.required');
					self.fillForm(self.settings);

					if (options.setAutoFocus) {
						self.setAutoFocus($('#' + self._$form.data('autofocus-field-id')));
					}

					if (callback) {
						callback();
					}

				});
			}

			this.getSettings = function(callback) {
				$.ajax({
					url: $form.data('api'),
					dataType: 'json',
					complete: function() {
						$form.removeClass('receiving-data');
					},
					success: function(res) {
						self.settings = res;

						if (callback) {
							callback();
						}

					},
					error: function(e) {
						self._$form.addClass('api-error');
						hideOneShowOther(self.$contentBlock, self.$apiErrorBlock);
					}
				});
			}

			this.showCaptcha = function(focus) {
				var $captchaBlock = this._$form.find('.captcha-block');
				this.$captchaInput = $captchaBlock.find('.captchaPhrase');
				this.$captchaIdInput = $captchaBlock.find('.captcha-id');
				this.$captchaImg = this._$form.find('.captcha-img');
				this.$captchaInput.addClass('required');
				this.$requiredFields = this.$requiredFields.add(this.$captchaInput);
				this.captchaShown = true;
				this.generateCaptcha();

				this.$captchaImg.on('click', function() {
					self.generateCaptcha();
				});

				$captchaBlock.slideDownFadeIn(transitionDuration, function() {

					if (focus) {
						this.$captchaInput.focus();
					}
					
				});
			}

			this.generateCaptcha = function() {
				$.ajax({
					url: self.$captchaImg.data('src'),
					dataType: 'json',
					method: 'GET',
					success: function(res) {
						self.$captchaIdInput.val(res.meta.captchaUid);
						self.$captchaImg.attr('src', 'data:' + res.meta.type + ';' + res.meta.encode + ',' + res.meta.image);
						self.$captchaInput.val('');
					},
					error: function(res) {
						self._$form.addClass('api-error');
						hideOneShowOther(self.$contentBlock, self.$apiErrorBlock);
						// console.log('Something with captcha (request)');
					}
				});
			}

			this.fillForm = function(settings) {
				this.selects = this._$form.data('selects') || this.selects;
				this.radios = this._$form.data('radios') || this.radios;
				this.inputs = this._$form.data('inputs');

				if (this.selects) {
					this.fillSelects(this.selects, settings);
				}

				if (this.radios) {
					this.fillRadios(this.radios, settings);
				}

				if (this.inputs) {
					this.fillInputs(this.inputs, settings);
				}

				if (this.settings.isCaptchaRequired) {
					this.showCaptcha();
				}

			}

			this.fillSelects = function(selectsObject, settings) {
				var callback;

				$.each(selectsObject, function(key, selectId) {
					callback = settings[key + 'Callback'] || key + 'Callback';
					self.fillSelect($('#' + selectId), settings[key], settings[key + 'Def'], callback);
				});
			}

			this.fillSelect = function($select, data, defVal, callback) {
				var strToInsert;

				$.each(data, function(value, text) {

					if ($.isArray(data)) {
						value = text;
					}

					strToInsert += '<option value="' + value + '"' + ((defVal === value) ? ' selected' : '') + ' data-value="' + value + '">' + text + '</option>';
				});

				$select.empty().append(strToInsert).data('default-value', defVal);

				if (callbacks[callback]) {
					callbacks[callback].call(this, $select);
				}

				$select.trigger('chosen:updated');
			}

			this.fillRadios = function(radiosObject, settings) {
				$.each(radiosObject, function(key, radioBlockId) {
					self.fillRadio($('#' + radioBlockId), settings[key], settings[key + 'Def']);
				});
			}

			this.fillRadio = function($radioBlock, data, defVal) {
				var radioItemTemplate,
					radioItem;

				radioItemTemplate = $radioBlock.children();
				$radioBlock.empty();

				$.each(data, function(value, text) {

					if ($.isArray(data)) {
						value = text;
					}

					radioItem = radioItemTemplate.clone();
					var curRadioItemInput = radioItem.find('input');

					curRadioItemInput.val(value).attr({
						'id': curRadioItemInput.attr('id') + value,
						'class': curRadioItemInput.attr('class') + value
					});

					if (value === defVal) {
						curRadioItemInput.prop('checked', true);
					}

					var curRadioItemLabel = radioItem.find('label');
					curRadioItemLabel.attr('for', curRadioItemLabel.attr('for') + value)
									 .find('.text')
									 .html(curRadioItemLabel.data('text')//html - because of lp pamm callback form (in ru I get html entities)
									 .replace('%text%', text));

					$radioBlock.append(radioItem);
				});
			}
			
			this.fillInputs = function(inputsObject, settings) {
				// var callback;

				$.each(inputsObject, function(key, inputId) {
					// callback = key + 'Callback';
					self.fillInput($('#' + inputId), settings[key + 'Def']);
				});
			}

			this.fillInput = function($input, defVal) {
				$input.val(defVal)
					  .trigger('change')
					  .attr('data-value', defVal);
			}

			this.setOption = function(key, value) {
				options[key] = value;
			}

			this.setAutoFocus = function(field) {
				var fieldPos = field.offset().top,
					fieldPosBot = fieldPos + field.outerHeight(),
					winHeight = $window.height(),
				    winScroll = $window.scrollTop();

				if (winHeight + winScroll > fieldPosBot) {
					
					if (winScroll < fieldPos) {
						field.focus();
					} else {
						$window.on('scroll.fldfocus', function() {
							winScroll = $window.scrollTop();
							if (winScroll < fieldPos) {
								field.focus();
								$window.off('scroll.fldfocus');
							}
						});
					}
				} else {
					$window.on('scroll.fldfocus', function () {
						winScroll = $window.scrollTop();
					
						if (winHeight + winScroll > fieldPosBot && winScroll < fieldPos) {
							field.focus();
							$window.off('scroll.fldfocus');
						}
					});
				}
			}

			this.initSteps = function() {
				this.step = 0;
				this.$stepBlocks = this._$form.find('.form-step');
				this.stepsNumber = this.$stepBlocks.length;
				this.currentStepBlock = this.$stepBlocks.eq(this.step);
				this.tabbedSteps = this.currentStepBlock.hasClass('dc-tab-content');//In case of switching is possible by clicable tabs

				if (this.tabbedSteps) {
					this.$stepBlocks.each(function() {

						if (self.$tabs) {
							self.$tabs = self.$tabs.add($('#' + $(this).data('tab-id')));
						} else {
							self.$tabs = $('#' + $(this).data('tab-id'));
						}
					});
				}
				//добавить сюда массив с табами, чтобы кликать быстро
			}

			this.nextStep = function() {

				if (this.step === undefined) {
					this.initSteps();
				}

				this.synchronizeWithTabs();
				this.toStep(this.step + 1);
			}

			this.synchronizeWithTabs = function() {

				if (this.tabbedSteps && !this.currentStepBlock.hasClass('active')) {//means that user clicked tabs
					this.currentStepBlock = this.$stepBlocks.filter('.active');
					this.step = this.$stepBlocks.index(this.currentStepBlock);
				}
			}

			this.toStep = function(stepToShowNumber) {

				if (stepToShowNumber < this.stepsNumber) {
					var stepToShowBlock = this.$stepBlocks.eq(stepToShowNumber);

					if (this.tabbedSteps) {
						this.$tabs.eq(stepToShowNumber).click();//to show new styles for tabs
					} else {
						hideOneShowOther(this.currentStepBlock, stepToShowBlock);
						//...
					}

					this.step = stepToShowNumber;
					this.currentStepBlock = stepToShowBlock;
				} else {
					this.send();
				}
			}

			this._$form.on('submit', function(e) {
				e.preventDefault();
				self.validate(true);
				
				if (self.isValid) {

					if (options.multySteps) {
						self.nextStep();
					} else {
						self.send();
					}

				}

			});

			this.validate = function(afterFormSubmit) {
				this.isValid = true;

				this.$requiredFields.each(function() {
					var $this = $(this);

					if (afterFormSubmit || !$this.hasClass('had-api-error')) {
						self.removeErrorFromField($this);
					}

					if (!$.trim($this.val())) {

						if (!self.checkNamespacedEvents($this, 'validate', ['change'])) {
							console.log('gogog')
							$this.on('change.validate', function() {
								self.validate(false);
							});
						}

						self.addErrorToField($this, $this.data('error-empty'), afterFormSubmit);
						self.isValid = false;
					}
				});

				if (this.isValid) {
					this.$requiredFields.each(function() {
						var $this = $(this);

						if (!self.checkNamespacedEvents($this, 'validate', ['change'])) {
							$this.on('change.validate', function() {
								self.validate(false);
							});
						}
					});
				}
			}

			this.checkNamespacedEvents = function($obj, namespace, eventsToCheck) {
				var eventsObj = $._data($obj[0], 'events'),
				    eventsExist = false;
				$.each(eventsObj, function() {
					$.each(this, function() {

						if (eventsToCheck && eventsToCheck.indexOf(this.type) != -1 && this.namespace === namespace) {
							eventsExist = true;
						}

					});
				});
				return eventsExist;
			}

			this.addErrorToField = function($field, errorText, afterFormSubmit) {
				var errorBlock = $field.parents('.error-parent');

				errorBlock.addClass('has-error');
				errorBlock.find('.error-text').text(errorText);

				if (afterFormSubmit) {
					self._$form.find('.has-error').eq(0).find('input').focus();
				}

			}

			this.removeErrorFromField = function($field) {
				$field.parents('.error-parent').removeClass('has-error');
			}

			function getIsoTimeZoneOffset(offset) {
				var sign = (offset >= 0) ? '+' : '-';
				offset = Math.abs(offset);
				return sign + format(offset / 60) + ':' + format(offset % 60);

				function format(number) {
					var norm = Math.floor(number);
					return (norm < 10 ? '0' : '') + norm;
				}
			}
			
			var $fullPhoneInput,
			    $gmtInput;

			this.send = function() {
				var self = this;

				if ($fullPhoneInput === undefined) {//to do it once
					$fullPhoneInput = this._$form.find('.full-phone-input');
				}

				if ($fullPhoneInput.length) {
					$fullPhoneInput.val($('#' + $fullPhoneInput.data('code-id')).val() + $('#' + $fullPhoneInput.data('number-id')).val());
				}

				if ($gmtInput === undefined) {//to do it once
					$gmtInput = this._$form.find('#' + self.name + '-gmt');
					
					if ($gmtInput.length) {
						$gmtInput.val(getIsoTimeZoneOffset(-(new Date).getTimezoneOffset()));
					}
					
				}

				if (this.status !== 'sending') {//for preventing numerous sendings
					this.status = 'sending';
					this._$form.addClass('sending');

					if (this.$errorBottomBlock) {
						this.$errorBottomBlock.fadeOutSlideUp(transitionDuration*2, function() {
							self.$errorBottomBlockText.empty();
							sendRequest();
						});
					} else {
						sendRequest();
					}

					function sendRequest() {
						$.ajax({
							url: self._$form.data('handler'),
							method: 'POST',
							dataType: 'json',
							data: self._$form.serialize(),
							xhrFields: {
								withCredentials: true
							},
							complete: function() {
								self._$form.removeClass('sending');
								self.status = 'sent';
							},
							success: function(e) {
								self.success(e);
								// self.error(e);
							},
							error: function(e) {
								// self.success();
								// e = {
								// 	responseJSON: {
								// 		errors:
								// 			[
								// 				{
								// 					status: 400,
								// 					code: 146819,
								// 					title: 'Извините, техническая ошибка базы данных. Пожалуйста, обратитесь в службу поддержки, указав следующий код ошибки: 14782389'
								// 				}
								// 			]
								// 	}
								// };
								self.error(e);
							}
						});
					}
				}

			}

			this.iconedFormPrepare = function(result) {
				
				
			}

			this.iconedFormResultAnimate = function(result) {//animation after successful or error sending
				var $actualBlock;
				this.$iconedElement = self._$form.parents('.iconed-element');
				
				if (this.$iconedElement.length) {

					if (result === 'success') {
						$actualBlock = self.$successBlock;
					} else {
						$actualBlock = self.$errorBlock;
					}

					this.$iconedElement.on('popup.closed', function() {
						self.$iconedElement.removeClass(result + ' pre-success');
						hideOneShowOther($actualBlock, self.$contentBlock);
					});

					this.$iconedElement.addClass('pre-success');
					setTimeout(function() {self.$iconedElement.addClass(result)}, transitionDuration);
				}

			}

			this.success = function(callback) {

				hideOneShowOther(self.$contentBlock, self.$successBlock, function() {

					self.iconedFormResultAnimate('success');

					if (callback) {
						callback();
					}

				});
			}

			this.error = function(e) {

				if (e.responseJSON && e.responseJSON.errors && e.responseJSON.errors.length) {
					$.each(e.responseJSON.errors, function() {
						var $errorField = self._$form.find($('#' + self.name + '-' + this.source));

						if ($errorField.length) {

							if (this.source == 'captchaPhrase') {
								if (self.captchaShown) {
									self.generateCaptcha();

								} else {
									self.showCaptcha(true);
								}
							}

							if (options.multySteps) {
							
								if ($errorField.is(':visible')) {
									self.addErrorToField($errorField, $errorField.data('error-invalid'), true);
								} else {
									self.toStep(self.$stepBlocks.index($errorField.parents('.form-step')));
									self.addErrorToField($errorField, $errorField.data('error-invalid'), true);
								}
								
							} else {
								self.addErrorToField($errorField, $errorField.data('error-invalid'), true);
							}

							if (!$errorField.hasClass('had-api-error')) {
								$errorField.addClass('had-api-error');//Not to remove error info after changing field value
							}

						} else {
							
							if (this.title) {
								self.$errorBottomBlock = self._$form.find('.bottom-error-block');
								self.$errorBottomBlockText = self.$errorBottomBlock.find('.text');
									// console.log($errorBottomBlock,$errorTextBlock)
								self.$errorBottomBlockText.text(this.title);
								self.$errorBottomBlock.slideDownFadeIn(transitionDuration*2);
								// self.addCommonError(this.title);
							} else {
								self.showCommonApiError();
							}

						}

						dataLayer.push({
							'event': 'error',
							'eventCategory': 'demoForm',
							'eventAction': this.title || 'unknown'
						});

					});
				} else {
					this.showCommonApiError();
				}
			}

			this.showCommonApiError = function() {
				self._$form.addClass('api-error');
				hideOneShowOther(self.$contentBlock, self.$errorBlock, function() {
					self.iconedFormResultAnimate('error');
				});
			}
		}

		function DemoForm($form, options) {
			Form.apply(this, arguments);

			var self = this;

			this.$accTypeCheckboxes = $form.find('#demo-acc-types').find('.acc-type-checkbox')
				.on('click', function(e) {
					var nothingChecked = true;
					self.$accTypeCheckboxes.each(function() {

						if ($(this).is(':checked')) {
							nothingChecked = false;
							return false;
						} else {
							
							if ($(this).is('[readonly]')) {//for form, embed in mobile JForex app (I add readonly attribute to #demo-jforex checkbox)
								return false;
							}

						}

					});

					if (nothingChecked) {
						e.preventDefault();
					}

				})
				.on('change', function(e) {
					triggerAccTypeCheckbox($(this));
				});

			function triggerAccTypeCheckbox($checkbox) {

				if ($checkbox.val()) {
					$checkbox.val('');
					$form.removeClass($checkbox.data('acc-sett-vis-class'));
				} else {
					$checkbox.val('1');
					$form.addClass($checkbox.data('acc-sett-vis-class'));
				}
			}

			this.$accTypeCheckboxes.each(function() {//fix for FF after refreshing page if value of checkbox doesn't match to checked state
				var $this = $(this);

				if ($this.is(':checked')) {
					if (!$this.val()) {
						triggerAccTypeCheckbox($this);
					}
				} else {
					if ($this.val()) {
						triggerAccTypeCheckbox($this);
					}
				}
			});

			this.formatSettings = function() {
				// console.log('country',country);
				var country = {};

				$.each(this.settings.meta.countries, function(key, value) {
					country[key] = value.callingCode + ' ' + value.name;
					// console.log(key, value);
				});
				// this.settings.meta.general.defaultCountry = 'US';

				this.formatedSettings = {//prepare them to standart fill... methods
					country: country,
					countryDef: (this.settings.meta.defaultCountry) ? ((self.settings.meta.bannedCountryList.indexOf(this.settings.meta.defaultCountry) != -1) ? 'CH': this.settings.meta.defaultCountry) : 'CH',//if no default country in settings - set CH; if default country in settings is in banned list - set CH (to show user notification, when he chose his country. Otherwise, he would see notification on every page (in quick demo))
					countryCallback: 'demoCountryCallback'
				}
			}

			var parentFillForm = this.fillForm;

			this.fillForm = function() {
				this.selects = $form.data('common-selects') || $form.data('selects');//{'name in api': 'select id'}
				this.radios = {};

				this.formatSettings();//api json is too compicated, so we need to format selects data to common view

				parentFillForm.call(this, this.formatedSettings);

				if (this.settings.meta.isCaptchaRequired) {
					this.showCaptcha(false);
				}
				
			}

			var parentValidate = this.validate;

			this.validate = function(afterFormSubmit) {
				parentValidate.call(this, afterFormSubmit)

				if (!this.isValid) {

					if (self._$form.hasClass('validated')) {//for availability of tabs
						self._$form.removeClass('validated');
					}

				} else {

					if (!self._$form.hasClass('validated')) {
						self._$form.addClass('validated');
					}

				}

			}

			// this.checkMobForSuccess = function() {
			// 	var mobile = jscd.checkMob();

			// 	if (mobile) {
			// 		this.$successBlock.addClass('mobile');

			// 		if (jscd.checkIPad()) {
			// 			this.$successBlock.addClass('ipad');
			// 		}
			// 	} else {
			// 		var os = jscd.getOs(),
			// 		    osBits = jscd.getBits(),
			// 		    installDefLink = this.$successBlock.find('#install-jf-def-link'),
			// 		    correctDefLink = this.$successBlock.find('.' + os.toLowerCase() + '-' + osBits);
			// 		installDefLink.text(correctDefLink.text()).attr('href', correctDefLink.attr('href'));
			// 		correctDefLink.remove();
			// 	}
			// }

			this.replaceEmail = function() {
				this.$successBlock.find('.main-text').html(function(index, oldhtml) {
					return oldhtml.replace('%email%', '<span class="email">' + self._$form.find('#demo-email').val() + '</span>')
				});
			}
			
			this.googleAnalitics = function() {
				var demoType = '';
				this.$accTypeCheckboxes.each(function() {
					var $this = $(this);

					if ($this.is(':checked')) {
						demoType += $this.data('ga-id');
					}

				});
				dataLayer.push({
					'event': self.$successBlock.data('gtm-event'),
					'eventCategory': self.$successBlock.data('gtm-event-category'),
					'demoType': demoType
				});

				//Old system. Must be removed
				// var ifrCont = document.createElement("iframe");
				// ifrCont.src = this.$successBlock.data('success-iframe');
				// document.body.appendChild(ifrCont);
				// hideIframe(ifrCont);
				// // прячем фрейм
				// function hideIframe(iframeNode) {
				// 	iframeNode.style.position = 'absolute';
				// 	iframeNode.style.left = '0px';
				// 	iframeNode.style.top = '0px';
				// 	iframeNode.style.height = '1px';
				// 	iframeNode.style.width = '1px';
				// 	iframeNode.style.visibility = 'hidden';
				// }
			}
		}

		function QuickDemoForm($form, options) {
			DemoForm.apply(this, arguments);

			var self = this;

			var parentSuccess = this.success;

			this.success = function() {
				// this.checkMobForSuccess();
				this.replaceEmail();
				parentSuccess.call(this, function() {
					self.googleAnalitics();
				});
			}
		}

		var $quickDemoForm = $('#registration-form');

		if ($quickDemoForm.length) {
			var quickDemoForm = new QuickDemoForm($quickDemoForm, {
				setAutoFocus: true
			});
			quickDemoForm.init(function(){
				// console.log('hohoh')
			});
		}

		var $selects = $('.select');

		$selects.chosen({
			width: '100%'
		});

		$selects.on('change', function() {//for autocomlete
			$(this).trigger('chosen:updated');
		});

		var callbacks = {};

		callbacks['countryCallback'] = function($select) {
			var self = this;
			var phoneCodeOptions = $select.find('option');
			formatPhoneCodes($select, phoneCodeOptions);

			function formatPhoneCodes($select, phoneCodeOptions) {
				phoneCodeOptions.each(function() {
					var $this = $(this);
					$this.html(formatPhoneCode($this.text()));
					$select.trigger('chosen:updated');
				});
			}
			function formatPhoneCode(text) {
				return '<b>' + text.replace(/\+\d+\s/, '$&</b> <i>') + '</i>';
			}
			function cutPhoneCode(str) {
				return str.match(/\+\d+/)[0];
			}

			var phoneCodeNumberInput = $('#' + $select.data('code-input-id'));

			setPhoneCode(getActiveOptionText($select), phoneCodeNumberInput);

			$select.on('change', function() {
				setPhoneCode(getActiveOptionText($select), phoneCodeNumberInput);
			});

			function setPhoneCode(str, phoneCodeNumberInput) {
				phoneCodeNumberInput.val(cutPhoneCode(str));
			}
			function getActiveOptionText($select) {
				return $select.children(':selected').text();
			}
		}

		callbacks['demoCountryCallback'] = function($select) {
			callbacks['countryCallback'].call(this, $select);
			var self = this;

			if (this.settings.meta.bannedCountryList) {
				var bannedText = this._$form.data('banned-text'),
				    japanText = this._$form.data('japan-text'),
				    $errorBlock = this._$form.find('#demo-top-error-block'),
				    $errorBlockText = $errorBlock.find('.text');

				$select.on('change', function() {
					var curVal = $select.val();
					if (self.settings.meta.bannedCountryList.indexOf(curVal) != -1) {

						if (curVal == 'JP') {
							$errorBlockText.html(japanText);
						} else {
							$errorBlockText.html(bannedText);
						}

						$errorBlock.slideDownFadeIn(transitionDuration*2);
					} else {

						if ($errorBlock.is(':visible')) {
							$errorBlock.fadeOutSlideUp(transitionDuration, function() {
								$errorBlockText.empty();
							});
						}

					}


					$.each(self.accTypes, function(numb, accType) {//adding balances and currencies to formatedSettings
							
						if (self.formatedSettings[accType + 'Currency'].indexOf(self.settings.meta.countries[curVal].currency) != -1) {
							self.currencySelects[numb].val(self.settings.meta.countries[curVal].currency).change();
						} else if (self.currencySelects[numb].val() !== self.formatedSettings[accType + 'CurrencyDef']) {//For the case when used changed country and one of the selects doesn't contain such currency
							self.currencySelects[numb].val('USD').change();

						}
						
					});

				});
			}

		}
	});
})(jQuery);